import axios from 'axios';
import { API_URL } from '../config/api';

// Create axios instance for specialist API
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add specialist token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('specialist_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('specialist_token');
      localStorage.removeItem('specialist');
    }
    return Promise.reject(error);
  }
);

const specialistAuthService = {
  // Register specialist
  register: async (data) => {
    const response = await api.post('/specialist-auth/register', data);
    return response.data;
  },

  // Login specialist
  login: async (email, password, rememberMe = false) => {
    const response = await api.post('/specialist-auth/login', {
      email,
      password,
      rememberMe
    });
    return response.data;
  },

  // Get profile
  getProfile: async () => {
    const response = await api.get('/specialist-auth/profile');
    return response.data;
  },

  // Update profile
  updateProfile: async (profileData) => {
    const response = await api.put('/specialist-auth/profile', profileData);
    return response.data;
  },

  // Validate token
  validateToken: async () => {
    const response = await api.get('/specialist-auth/validate');
    return response.data;
  },

  // Upload avatar
  uploadAvatar: async (file) => {
    const formData = new FormData();
    formData.append('avatar', file);
    const response = await api.post('/specialist-auth/upload-avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  }
};

export default specialistAuthService;
